const configuredSiteUrl = process.env.REACT_APP_SITE_URL || "";

export function getSiteUrl() {
  const fallback = typeof window !== "undefined" ? window.location.origin : "";
  return (configuredSiteUrl || fallback).replace(/\/+$/, "");
}

export function getCanonicalUrl(pathname) {
  const path = `/${String(pathname || "").replace(/^\/+/, "")}`;
  return `${getSiteUrl()}${path}`;
}
